module.exports = __webpack_public_path__ + "media/images/realizacje/real17-68ef393c1237fe70b9f13990ea353620.png";